<template style="height:100%">
  <div class="main-content">
    <!--顶部-->
    <head-banner :searchPara="searchPara" @clickSearchData="clickSearchData"></head-banner>
    <!--中央区域-->
    <div class="wrapper_full mt20 bg_line">
      <div class="wrapper_width">
        <div class="detail_left ml_10">
          <div class="left_tree">
            <div class="resource_category">
              <ul>
                <li><a herf="#" :class="resourceSelectIndex === 3 ? 'resource-menu-select' : '' " @click="handleResourceCategoryClick(3)">图书</a></li>
                <li><a herf="#" :class="resourceSelectIndex === 2 ? 'resource-menu-select' : '' " @click="handleResourceCategoryClick(2)">报刊</a></li>
                <li><a herf="#" :class="resourceSelectIndex === 1 ? 'resource-menu-select' : '' " @click="handleResourceCategoryClick(1)">古籍</a></li>
              </ul>
            </div>
            <left-tree :paramData="treeParamData"  @categoryClick="categoryClick" v-if="categoryTreeVisible"></left-tree>
          </div>
          
          <div class="appexplain">
            <div class="explaintitle">产品介绍</div>
            <div class="explaincontent" v-html="appExplain"></div>
          </div>
        </div>
        <div class="detail_right">
          <component :is="columnCompName" :dataList="paramData" :ref="columnCompName" @clickReturnHome="clickReturnHome" @clickSearchData="clickSearchData"></component>
        </div>
      </div>
    </div>

    <!--底部-->
    <div style="..."></div>
    <foot-template></foot-template>
  </div>
</template>

<script>
  import bookColumn from "../column/bookcolumn";
  import searchList from "../column/searchList";
  import indexList from "../column/indexList"
  import leftTree from "../column/lefttree"
  import headBanner from "../template/head"
  import footTemplate from "../template/foot"
  import index_banner1 from '@/assets/site-image/banner.png'
  import index_banner2 from '@/assets/site-image/banner1.png'
  import { Message,MessageBox } from 'element-ui'
  import configJosn from "../../../static/config.json";
  export default {
    name: 'index',
    provide() {
      return { provideData: this };
    },
    components: {
      bookColumn,
      searchList,
      indexList,
      headBanner,
      leftTree,
      footTemplate
    },
    data () {
      return {
        columnCompName: "bookColumn",
        editSearchKeyWord: "",
        selectCategoryNode: null,
        headHeight: 320,
        bannerHeight: 290,
        screenWidth: 0,
        searchPara: {},
        resourceSelectIndex: 3,
        categoryTreeVisible: true,
        img_list: [index_banner1,index_banner2],
        treeParamData:{
          resourceCode: '3'
        },
        paramData: {
          title: "gary column title.",
          categroyGuid: "",
          queryWord: ""
        },
        queryEntity:{
          keyword: null,
          current: 1,
          pages: null,
          sizes: 10,
          total: 0,
          orderBy: null,
        }
      }
    },
    created() {
      this.initData();
    },
    methods: {
      setSize: function() {
        this.bannerHeight = 270;//(400 / 1920) * this.screenWidth;
      },
      initData(){
        this.columnCompName = "bookColumn";
        this.searchPara.categoryCode = ''
        this.appExplain = configJosn.appExplain
       },
      handleResourceCategoryClick(resouceCode){
        this.resourceSelectIndex = parseInt(resouceCode)
        //this.selectCategoryNode.topResourceEntity = this.resourceSelectIndex
        this.treeParamData.resourceCode = resouceCode
        this.categoryTreeVisible = false;
        this.$nextTick(() => {
          this.categoryTreeVisible = true;
        })
      },
      categoryClick(categoryItem){
        this.selectCategoryNode = categoryItem;
        if (this.selectCategoryNode.subNodeFlag != 0){
          const { href } = this.$router.resolve({
            name: "pageindex",
            query: this.selectCategoryNode.topResourceEntity,
          });
          window.open(href, '_blank');
        }else {
          this.columnCompName = searchList;
          this.$nextTick(() => {
            console.log('category query:  ' , categoryItem.categoryCode)
            this.searchPara.categoryCode = categoryItem.categoryCode
            this.$refs[this.columnCompName].queryDataByCategory(categoryItem.categoryCode, categoryItem.categoryName,categoryItem.resourceDbGuid)
          })
        }
      },
      clickReturnHome(){
        this.columnCompName = "bookColumn";
      },
      clickSearchData(searchType,searchKeyword,categoryCode){
        this.columnCompName = searchList;
        this.$nextTick(() => {
          console.log('query categoryCode before : ',categoryCode,searchKeyword)
          this.$refs[this.columnCompName].queryDataByTitle(searchType,categoryCode,searchKeyword)
        })
      }
    },
    mounted() {
      this.screenWidth = window.innerWidth;
      this.setSize();
      window.onresize = () => {
        this.screenWidth = window.innerWidth;
        this.setSize();
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import url('../../styles/common.css');
  @import url('../../styles/main.css');
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue